import { Component } from '@angular/core';

@Component({
  selector: 'app-login-layout',
  styleUrls: ['./home-layout.sass'],
  template: `
    <div class="min-vh-100 d-flex flex-column">
      <app-top-bar></app-top-bar>
      <div class="d-flex flex-row flex-grow-1">
        <app-side-bar></app-side-bar>
        <div class="main p-3 flex-grow-1">
          <router-outlet></router-outlet>
        </div>
      </div>
      <app-bottom-bar></app-bottom-bar>
    </div>
  `,
})
export class HomeLayoutComponent {}
